import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.1156 0.908258C13.8338 0.633677 13.4978 0.5 13.0968 0.5H1.44155C1.04052 0.5 0.708129 0.633677 0.42271 0.908258C0.13729 1.17923 0 1.49716 0 1.88013V13.1199C0 13.4992 0.13729 13.8172 0.42271 14.0917C0.708129 14.3663 1.04052 14.5 1.44155 14.5H13.0968C13.4978 14.5 13.8302 14.3663 14.1156 14.0917C14.401 13.8172 14.5383 13.4992 14.5383 13.1199V1.88013C14.5383 1.49716 14.401 1.17923 14.1156 0.908258ZM13.3244 13.3439H1.21394V4.86439H13.3244V13.3439ZM13.3244 3.71187H1.21394V1.65252H13.3244V3.71187Z",
      fill: "#949494"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.77297 7.49835C4.77297 7.72597 4.69349 7.91745 4.53091 8.06919C4.37194 8.22455 4.17323 8.30042 3.93839 8.30042C3.70355 8.30042 3.50484 8.22455 3.34587 8.06919C3.18691 7.91745 3.10742 7.72597 3.10742 7.49835C3.10742 7.27074 3.18691 7.07926 3.34587 6.92751C3.50484 6.77216 3.70355 6.69629 3.93839 6.69629C4.17323 6.69629 4.37194 6.77216 4.53091 6.92751C4.69349 7.07926 4.77297 7.27074 4.77297 7.49835Z",
      fill: "#949494"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.10041 7.49835C8.10041 7.72597 8.02093 7.91745 7.86196 8.06919C7.70299 8.22455 7.50428 8.30042 7.26944 8.30042C7.03461 8.30042 6.8359 8.22455 6.67693 8.06919C6.51796 7.91745 6.43848 7.72597 6.43848 7.49835C6.43848 7.27074 6.51796 7.07926 6.67693 6.92751C6.8359 6.77216 7.03461 6.69629 7.26944 6.69629C7.50428 6.69629 7.70299 6.77216 7.86196 6.92751C8.02093 7.07926 8.10041 7.27074 8.10041 7.49835Z",
      fill: "#949494"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.4312 7.49835C11.4312 7.72597 11.3517 7.91745 11.1927 8.06919C11.0338 8.22455 10.835 8.30042 10.6002 8.30042C10.3654 8.30042 10.1667 8.22455 10.0077 8.06919C9.84511 7.91745 9.76562 7.72597 9.76562 7.49835C9.76562 7.27074 9.84511 7.07926 10.0077 6.92751C10.1667 6.77216 10.3654 6.69629 10.6002 6.69629C10.835 6.69629 11.0338 6.77216 11.1927 6.92751C11.3517 7.07926 11.4312 7.27074 11.4312 7.49835Z",
      fill: "#949494"
    }, null, -1)
  ])))
}
export default { render: render }